export const googleApi = "https://maps.googleapis.com/maps/api/js?v=3&key=AIzaSyAyfVnxQL9gRDT1v-Ii99ANum4J6rr2sXE&libraries=geometry,places&sensor=false&language=en";
export const requestUrl = "/service/api";
export const env = true; // 测试环境：false，生产环境：true
